<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch" [hidden]="!ViewReady">
    <!-- <div fxHide fxShow.xs>xs</div>
    <div fxHide fxShow.sm>sm</div>
    <div fxHide fxShow.md>md</div> -->
    <div fxLayout="row" fxLayoutAlign="space-between start" class="title-line">
        <h1 [ngClass.sm]="['mat-display-1', 'margin-bottom-none']" [ngClass.lt-sm]="'mat-display-2'" [ngClass.gt-sm]="'mat-display-3'">
            <span fxHide.lt-sm>Schools Support Tracker</span>
            <span fxHide.gt-xs>SST</span>
        </h1>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div fxLayout="column" fxLayoutAlign="start end">
                <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
                    <button
                        type="button"
                        fxShow
                        fxHide.xs
                        *ngIf="User?.AuthToken"
                        mat-flat-button
                        color="primary"
                        (click)="GoHome()"
                        aria-label="Go to home page"
                    >
                        <mat-icon>home</mat-icon>
                        <span>Home</span>
                    </button>
                    <button
                        type="button"
                        fxHide
                        fxShow.xs
                        *ngIf="User?.AuthToken"
                        mat-mini-fab
                        color="primary"
                        (click)="GoHome()"
                        aria-label="Go to home page"
                    >
                        <mat-icon>home</mat-icon>
                    </button>
                    <button
                        type="button"
                        mat-mini-fab
                        color="primary"
                        (click)="ToolbarSettings()"
                        aria-label="See application settings"
                    >
                        <mat-icon>settings</mat-icon>
                    </button>
                    <button
                        type="button"
                        mat-mini-fab
                        color="primary"
                        (click)="ToolbarAbout()"
                        aria-label="See application help information"
                    >
                        <mat-icon>help</mat-icon>
                    </button>
                    <button
                        type="button"
                        fxShow
                        fxHide.xs
                        *ngIf="User?.AuthToken"
                        mat-flat-button
                        (click)="ToolbarLogout()"
                        aria-label="Logout of application"
                    >
                        <mat-icon>exit_to_app</mat-icon>
                        <span>Logout</span>
                    </button>
                    <button
                        type="button"
                        fxHide
                        fxShow.xs
                        *ngIf="User?.AuthToken"
                        mat-mini-fab
                        (click)="ToolbarLogout()"
                        aria-label="Logout of application"
                    >
                        <mat-icon>exit_to_app</mat-icon>
                    </button>
                </div>
                <app-user-info *ngIf="User" [user]="User"></app-user-info>
            </div>
            <div class="small-logo-box" fxHide.gt-sm fxFlex="1 0 auto">
                <img class="pcps-logo" src="/assets/images/WhiteLogoOnly.svg" />
            </div>
            <div class="logo-box" fxHide.lt-md>
                <img class="pcps-logo" src="/assets/images/PCPS_White.svg" />
            </div>
        </div>
    </div>
    <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" class="scrollable">
        <!-- Flair background elements -->
        <div class="chalk class_of" [ngClass.xs]="'xs'" [ngClass.sm]="'sm'">Class of 2027!</div>
        <div class="chalk lovepolk" [ngClass.xs]="'xs'" [ngClass.sm]="'sm'">#LovePolkSchools</div>
        <div class="chalk pyth" [ngClass.xs]="'xs'" [ngClass.sm]="'sm'">a<sup>2</sup> + b<sup>2</sup> = c<sup>2</sup></div>
        <!-- <div class="chalk notes">&#x2669;&#x266A;&#x266B;&#x266C;</div> -->
        <!-- <div class="devbar" *ngIf="DevSite === true && SmallDisplay"><div>Development Site</div></div> -->
        <div class="updatebar" *ngIf="UpdateAvailable === true">
            <button type="button" mat-raised-button color="accent" (click)="GetUpdate()">
                A site update is available. Click here for details.
            </button>
        </div>
        <div fxFlex="1 1 auto" class="routerwrapper" fxLayout="column" fxLayoutAlign="start stretch">
            <!--
            [class.updatebarheight]="UpdateAvailable === true"
            [class.devbarheight]="DevSite === true" -->
            <router-outlet class="content"></router-outlet>
        </div>
    </div>
</div>
